import { render, staticRenderFns } from "./Obra.vue?vue&type=template&id=ab130746&"
import script from "./Obra.vue?vue&type=script&lang=js&"
export * from "./Obra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports